let flagsmith: any | undefined

export const setFlagsmith = (flagsmithInstance: any) => {
    flagsmith = flagsmithInstance;
}

export const getFlagsmith = () => {
    return flagsmith;
}
